import React, { Fragment } from 'react';
import EachDot from 'components/EachDot';

const dots = [
  {
    delay: 500,
  },
  {
    delay: 540,
  },
  {
    delay: 580,
  },
];

const ThreeDotAnimated = () => {
  //! State

  //! Function

  //! Render
  return (
    <Fragment>
      {dots.map((el, index) => (
        <EachDot key={`${index}-${el.delay}`} delay={el.delay} />
      ))}
    </Fragment>
  );
};

export default React.memo(ThreeDotAnimated);
